// Meldet dem Backend, dass ein persönlicher Bewerbungslink (?r=firma) geöffnet wurde.
// Erst nach echter Interaktion (Maus, Scrollen, Tippen, Taste) und frühestens 1,5 s nach dem Laden,
// damit Link-Scanner der Mailprogramme keinen Fehlalarm auslösen. Pro Tab und Code nur einmal.
// Gleiche Datei auch in FlashWrite (src/lib/visitPing.js).
const REF_PATTERN = /^[a-z0-9][a-z0-9._-]{0,39}$/;
const EVENTS = ['pointermove', 'pointerdown', 'wheel', 'scroll', 'touchstart', 'keydown'];

export function setupVisitPing(endpoint, site) {
  try {
    const ref = (new URLSearchParams(window.location.search).get('r') || '').trim().toLowerCase();
    if (!REF_PATTERN.test(ref) || navigator.webdriver) return;

    const storageKey = `visit-ping:${site}:${ref}`;
    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch (e) { /* ohne sessionStorage einfach weiter */ }

    const loadedAt = Date.now();
    let sent = false;

    const onInteraction = (event) => {
      if (sent || !event.isTrusted || document.visibilityState !== 'visible') return;
      if (Date.now() - loadedAt < 1500) return;
      sent = true;
      EVENTS.forEach((name) => window.removeEventListener(name, onInteraction, true));
      try { sessionStorage.setItem(storageKey, '1'); } catch (e) { /* egal */ }

      const body = JSON.stringify({ ref, site, path: window.location.pathname });
      const queued = navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain' }));
      if (!queued) {
        fetch(endpoint, { method: 'POST', body, headers: { 'Content-Type': 'text/plain' }, mode: 'no-cors', keepalive: true }).catch(() => {});
      }
    };

    EVENTS.forEach((name) => window.addEventListener(name, onInteraction, { capture: true, passive: true }));
  } catch (e) {
    // Darf die Seite nie stören
  }
}
